<!-- 上传进度条 -->
<template>
  <div id='progress'>
    <div class="inner" ref="myprogress" id="myprogress"></div>
    <img :src="suffixUrl" alt="img" class="suffix">
    <p class="name">{{file.name}}{{file.suffix}}</p>
    <p class="info">{{`${bytesToSize(file.size)} / ${(progress * 100).toFixed(2)}%`}}</p>
    <img src="/img/delete.png" alt="delete" class="delete pointer" @click="doDelete" v-show="progress===1">
  </div>
</template>

<script>
import api from '@/services/server.js'
import { getSuffix } from '@/utils/filter.js'
import { bytesToSize } from '@/utils'
export default {
  data () {
    return {
      suffixUrl: '',
      progress: 1,
      myprogress: {}
    }
  },
  props: {
    file: Object
  },
  mounted () {
    this.myprogress = document.getElementById('myprogress')
    this.doUpdate(this.myprogress, this.file)
  },
  watch: {
    file: {
      handler () {
        this.doUpdate(this.myprogress, this.file)
      },
      deep: true
    }
  },
  methods: {
    doUpdate (el, file) {
      console.log(this.file.progress)
      this.suffixUrl = getSuffix(this.file.suffix)
      this.progress = this.file.progress
      let distance = 510 - 510 * this.progress
      // this.$refs.myprogress.style.left = `-${distance}px`
      console.log(this.$refs.myprogress.style.left = `-${distance}px`)
      this.$refs.myprogress.style.transition = 'all .4s;'
    },
    doDelete () {
      this.$confirm('此操作将删除该文件, 是否继续?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          feedback_id: this.file.id
        }
        api.feedbackDelete(params).then(res => {
          if (res.ok) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.$emit('delete', true)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    bytesToSize (size) {
      return bytesToSize(size)
    }
  }
}
</script>
<style scoped lang='scss'>
#progress {
  height: 70px;
  overflow: hidden;
  position: relative;
  margin-bottom: 2px;
  position: relative;
  .suffix {
    width: 32px;
    height: 38px;
    position: absolute;
    z-index: 1;
    top: 16px;
    left: 20px;
  }
  .name {
    color: #333;
    display: inline-block;
    vertical-align: baseline;
    transform: translateY(-10px);
    position: absolute;
    z-index: 1;
    top: 20px;
    left: 70px;
    width: 350px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .info {
    color: #666;
    font-size: 12px;
    position: absolute;
    z-index: 1;
    top: 40px;
    left: 70px;
  }
  .delete {
    width: 18px;
    height: 18px;
    position: absolute;
    z-index: 1;
    top: 26px;
    right: 18px;
    &:hover {
      opacity: 0.7;
    }
  }
}
#myprogress {
  width: 510px;
  height: 70px;
  background: rgba(244, 251, 253, 1);
  // transform: translateX(-510px);
  position: absolute;
  left: -510px;
  top: 0;
}
</style>
